export default __webpack_public_path__ + "static/media/org_entity.f7a88bba.svg";